import Framework, { BaseService } from '@greenville/framework';
import omit from 'lodash/omit';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class TrendsFeedbackChartsDetailsService extends BaseService {
  constructor() {
    super(constants.GET_AI_CHARTS_UTILITY_LIST_DATA, 'trendsFeedbackChartsDetailsService');
  }

  async handleEvent(eventName, event) {
    let { payload } = utils.buildRequestPartsFromPayload(event);
    const { headers } = utils.buildRequestPartsFromPayload(event);
    const { type, feedback } = payload;
    payload = omit(payload, ['type', 'feedback']);
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackbv2').post(`/trends/count/feedback/${type}/${feedback}`, payload, {
        headers: enhancedHeaders
      });
    }
    // Default flow: aiadminv2 with automatic token handling
    return this.getClient('aiadminv2').post(`/trends/count/feedback/${type}/${feedback}`, payload, { headers });
  }

  handleResponse(response) {
    Framework.getStoreRegistry().getStore('aiFeedbackChartsDetails').setResponse(response.data);
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore('aiFeedbackChartsDetails').resetStoreValues();
  }
}
